import React from "react";
import { Link } from "react-router-dom";
import { 
  FaLightbulb, 
  FaUsers, 
  FaChartLine, 
  FaDatabase,
  FaArrowRight 
} from "react-icons/fa";
import styles from "../../styles/pages/static/AboutPage.module.css";
import PageSeo from "../../components/common/PageSeo";

const AboutPage = () => {
  return (
    <div className="pageContainer">
      <PageSeo
        title="About Us"
        description="Learn about Simpary's mission to help you compare, decide, and connect."
        pathname="/about"
      />
      <div className="innerContainer">
        <div className={styles.aboutPage}>
        {/* Hero Section */}
        <section className={styles.heroSection}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>About Simpary</h1>
            <p className={styles.heroSubtitle}>
              Your smart solution for comparing electronics, making informed
              choices, and finding the right product based on your needs.
            </p>
          </div>
        </section>

        {/* Mission & Vision Section */}
        <section className={styles.missionSection}>
          <div className={styles.container}>
            <div className={styles.missionGrid}>
              <div className={styles.missionCard}>
                <h2>Our Mission</h2>
                <p>
                  To simplify the electronics buying journey by providing 
                  comprehensive, unbiased comparisons and empowering consumers 
                  to make confident, informed decisions.
                </p>
              </div>
              <div className={styles.missionCard}>
                <h2>Our Vision</h2>
                <p>
                  To become the most trusted platform for electronics comparison, 
                  where every consumer can find their perfect product match through 
                  data-driven insights and community wisdom.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Key Features Section */}
        <section className={styles.featuresSection}>
          <div className={styles.container}>
            <h2 className={styles.sectionTitle}>What Makes Us Different</h2>
            <div className={styles.featuresGrid}>
              <div className={styles.featureCard}>
                <div className={styles.featureIcon}>
                  <FaLightbulb />
                </div>
                <h3>Smart Comparison Engine</h3>
                <p>
                  Our intelligent matching algorithm analyzes your needs and 
                  preferences to suggest the best products tailored specifically for you.
                </p>
              </div>

              <div className={styles.featureCard}>
                <div className={styles.featureIcon}>
                  <FaUsers />
                </div>
                <h3>Community-Driven Reviews</h3>
                <p>
                  Real experiences from real users. Our community shares honest 
                  reviews and insights to help you make better decisions.
                </p>
              </div>

              <div className={styles.featureCard}>
                <div className={styles.featureIcon}>
                  <FaChartLine />
                </div>
                <h3>Personalized Recommendations</h3>
                <p>
                  Get suggestions based on your preferences, budget, and usage 
                  patterns. Find products that truly match your lifestyle.
                </p>
              </div>

              <div className={styles.featureCard}>
                <div className={styles.featureIcon}>
                  <FaDatabase />
                </div>
                <h3>Comprehensive Database</h3>
                <p>
                  Access detailed specifications, prices, and comparisons across 
                  thousands of electronics from leading brands worldwide.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Statistics Section */}
        <section className={styles.statsSection}>
          <div className={styles.container}>
            <div className={styles.statsGrid}>
              <div className={styles.statCard}>
                <div className={styles.statNumber}>50,000+</div>
                <div className={styles.statLabel}>Active Users</div>
              </div>
              <div className={styles.statCard}>
                <div className={styles.statNumber}>10,000+</div>
                <div className={styles.statLabel}>Products</div>
              </div>
              <div className={styles.statCard}>
                <div className={styles.statNumber}>100,000+</div>
                <div className={styles.statLabel}>Comparisons Made</div>
              </div>
              <div className={styles.statCard}>
                <div className={styles.statNumber}>25,000+</div>
                <div className={styles.statLabel}>Reviews Shared</div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className={styles.ctaSection}>
          <div className={styles.container}>
            <div className={styles.ctaContent}>
              <h2>Ready to Find Your Perfect Match?</h2>
              <p>
                Join thousands of satisfied users who have found their ideal 
                electronics through our platform.
              </p>
              <Link to="/" className={styles.ctaButton}>
                Start Comparing <FaArrowRight />
              </Link>
            </div>
          </div>
        </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
